// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'

import { ProfilePicture } from '../ProfilePicture'
import { colors } from '@lmc/common/constants'

export default function ResidentPictureName(props) {
  const { data, isLogRemoved, onSelect, style } = props

  const redirect = () => onSelect(`residents/${data.id}/profile`)
  if (!data || !data.id) return <div style={styles.residentContainer} />

  const containerStyle = { ...styles.residentContainer, ...style }

  return (
    <div style={containerStyle}>
      <div className={css(classes.clickable)} onClick={redirect}>
        <ProfilePicture
          className={
            isLogRemoved
              ? css(classes.profilePicGreyed)
              : css(classes.profilePic)
          }
          url={data.picture}
          size={46}
        />
      </div>
      <a
        className={`${css(classes.title)} ${css(classes.clickable)}`}
        onClick={redirect}
        style={{
          marginTop: 12,
          color: isLogRemoved ? colors.darkgrey : null,
          overflowWrap: 'anywhere',
        }}
      >
        {data.name.first} {data.name.last}
      </a>
    </div>
  )
}

ResidentPictureName.propTypes = {
  data: PropTypes.object,
  isLogRemoved: PropTypes.bool,
  onSelect: PropTypes.func,
}

const styles = {
  residentContainer: {
    display: 'flex',
    marginRight: 12,
    minWidth: 160,
  },
}

const classes = StyleSheet.create({
  clickable: {
    cursor: 'pointer',
  },
  profilePic: {
    marginRight: 12,
  },
  profilePicGreyed: {
    marginRight: 12,
    opacity: 0.2,
  },
  residentContainer: {
    display: 'flex',
    marginRight: 12,
    width: '25%',
  },
  title: {
    color: colors.black,
    display: 'block',
    fontWeight: 600,
  },
})
